// ============================================================================
// nevPotlasView.js — a "Hiányzó nyelvi nevek pótlása" szakasz az admin "Szoba módosítása" oldalán (2026-10-20, v123; logika: nevPotlas.js).
// ============================================================================

import { t } from "./i18n.js";
import { el } from "./dom.js";
import { hianyzoNevek, mentesiTervek } from "./nevPotlas.js";

/**
 * @param {object} model { uiLang, rooms (admin lista), eloSzobak (élő lista, címkékhez), contentLangs, busy, nevPotlas }
 *   nevPotlas: null | {fazis: "fut"|"kesz"|"ment"|"vege", haladas:{n,m}, javaslatok, hibak, keretHiba, megszakadt, mentett, hiba}
 * @param {object} handlers onNevPotlasStart, onNevPotlasCancel, onNevPotlasSave, onNevPotlasDiscard
 */
export function renderNevPotlas(model, handlers) {
  const { uiLang, busy } = model;
  const np = model.nevPotlas || null;
  const kodok = Object.keys(model.contentLangs || {});
  const box = el("section", { class: "panel-section name-fill" });
  box.appendChild(el("h3", { text: t(uiLang, "admin.fillTitle") }));
  box.appendChild(el("p", { class: "hint", text: t(uiLang, "admin.fillHint") }));

  if (np && np.fazis === "fut") {
    box.appendChild(el("div", { class: "panel-status", role: "status", text: t(uiLang, "admin.fillProgress", { n: np.haladas ? np.haladas.n : 0, m: np.haladas ? np.haladas.m : 0 }) }));
    box.appendChild(el("button", { type: "button", class: "neutral-btn", text: t(uiLang, "admin.fillCancel"), onclick: handlers.onNevPotlasCancel }));
    return box;
  }

  if (np && (np.fazis === "kesz" || np.fazis === "ment")) {
    const terv = mentesiTervek(np.javaslatok || [], model.rooms || [], model.eloSzobak || [], kodok);
    box.appendChild(el("div", { class: "panel-status ok", role: "status", text: terv.ossz > 0 ? t(uiLang, "admin.fillReady", { n: terv.ossz }) : t(uiLang, "admin.fillNone") }));
    if (np.keretHiba) box.appendChild(el("div", { class: "panel-status err", role: "alert", text: t(uiLang, "admin.fillLimit") }));
    else if (np.hibak > 0) box.appendChild(el("div", { class: "panel-status err", role: "alert", text: t(uiLang, "admin.fillPartial", { n: np.hibak }) }));
    // v144: a fordítás elkészült, de hosszabb a megengedett szobanév-hossznál - az ok kimondása (nem általános "nem sikerült").
    if (np.tulHosszu > 0) box.appendChild(el("div", { class: "panel-status err", role: "alert", text: t(uiLang, "admin.fillTooLong", { n: np.tulHosszu }) }));
    if (np.hiba) box.appendChild(el("div", { class: "panel-status err", role: "alert", text: t(uiLang, "admin.fillFailed") }));
    // Az átnézhető lista: elem + a beírandó nevek (csak a még üres nyelvek).
    const lista = el("div", { class: "panel-list name-fill-list" });
    for (const j of np.javaslatok || []) {
      const f = j.feladat;
      const sorok = f.kodok.filter((k) => typeof (j.nevek || {})[k] === "string" && j.nevek[k].trim()).map((k) => `${k}: ${j.nevek[k].trim()}`);
      if (sorok.length === 0) continue;
      const cim = f.fajta === "cimke" ? `🏷️ ${f.nev}` : f.nev;
      lista.appendChild(el("div", { class: "name-fill-row" }, [el("div", { class: "primary", text: cim }), el("div", { class: "sub", lang: "und", text: sorok.join(" · ") })]));
    }
    box.appendChild(lista);
    box.appendChild(el("div", { class: "panel-row" }, [
      el("button", { type: "button", class: "neutral-btn", text: t(uiLang, "admin.fillDiscard"), disabled: busy || np.fazis === "ment", onclick: handlers.onNevPotlasDiscard }),
      el("button", { type: "button", class: "primary-btn compact", text: np.fazis === "ment" ? "…" : t(uiLang, "admin.fillSave", { n: terv.ossz }), disabled: busy || np.fazis === "ment" || terv.ossz === 0, onclick: handlers.onNevPotlasSave }),
    ]));
    return box;
  }

  if (np && np.fazis === "vege") {
    box.appendChild(el("div", { class: "panel-status " + (np.hiba ? "err" : "ok"), role: "status", text: np.hiba ? t(uiLang, "admin.fillFailed") : t(uiLang, "admin.fillSaved", { n: np.mentett || 0 }) }));
  }

  // Alap: összegzés + indítás.
  const h = hianyzoNevek(model.rooms || [], model.eloSzobak || [], kodok);
  if (!model.rooms) {
    box.appendChild(el("p", { class: "hint", text: t(uiLang, "common.loading") }));
  } else if (h.szobak.length + h.cimkek.length === 0) {
    box.appendChild(el("p", { class: "hint", text: t(uiLang, "admin.fillNothing") }));
  } else {
    box.appendChild(el("p", { class: "hint", text: t(uiLang, "admin.fillCount", { rooms: h.szobak.length, tags: h.cimkek.length }) }));
    box.appendChild(el("button", { type: "button", class: "neutral-btn", text: "✨ " + t(uiLang, "admin.fillStart"), disabled: busy, onclick: handlers.onNevPotlasStart }));
  }
  return box;
}
